import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from './configuration/network.service';
import { API } from './configuration/end-points';
import { CookieService } from 'ngx-cookie-service';
import { secureStorage } from './pages/Services/secure-storage';

//language code
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/locale/", ".json");
}

@Injectable()  
export class MyMissingTranslationHandler implements MissingTranslationHandler {
    constructor(private nts: NotTranslatedService) {}
    handle(params: MissingTranslationHandlerParams) {
        this.nts.notTranslated(params);
        //return '[MISSING]' + params.key;
        return params.key;
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotTranslatedService {
    missingKeys : string[] = [];
    constructor(
        private networkService: NetworkService,
        public cookieService: CookieService
    ) {}
    notTranslated(params) {
        const key = params.key;
        const currentLang = params.translateService.currentLang;
        if(currentLang){
            const arr = currentLang.split("_");
            if(!this.missingKeys.includes(key)){
                this.missingKeys.push(key);
                const encr = secureStorage.hash("currentUser");
                let accessToken;
                this.cookieService.check(encr) && (accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
                let url = "";
                if(accessToken && accessToken.accessToken){
                    url = API.TRANSLATION.MISSING_TRANSLATION_LOGGED_IN + "?sentence="+key+"&moduleId="+arr[0];
                    // this.networkService.addModel("",url).subscribe(
                    //     (response) => {
        
                    //     }
                    // );
    
                }else{
                    url = API.TRANSLATION.MISSING_TRANSLATION_LOGGED_OUT + "?sentence="+key+"&moduleId="+arr[0];
                    // this.networkService.basicPostApi("",url).subscribe(
                    //     (response) => {
        
                    //     }
                    // );    
                }
            }    
        }
    }
}

export function getRangeLabel(translate : TranslateService, page: number, pageSize: number, length: number): string {
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return translate.instant('Range', { startIndex: startIndex + 1, endIndex, length });
}  
  